import { ApiError } from "../api";

/**
 * Extract error message from unknown error type.
 * Handles:
 * - ApiError instances (from api-client)
 * - Standard Error instances
 * - Axios error responses (response.data.error.message)
 * - Objects with message property
 * - String errors
 */
export function getErrorMessage(e: unknown, fallback = "An error occurred"): string {
  // ApiError from api-client (already has extracted message)
  if (e instanceof ApiError) return e.message;

  // Standard Error
  if (e instanceof Error) return e.message;

  // Object with potential nested axios response or message
  if (typeof e === "object" && e !== null) {
    // Check for axios error response structure: response.data.error.message
    if ("response" in e) {
      const response: unknown = e.response;
      if (typeof response === "object" && response !== null && "data" in response) {
        const data: unknown = response.data;
        if (typeof data === "object" && data !== null && "error" in data) {
          const error: unknown = data.error;
          if (typeof error === "object" && error !== null && "message" in error) {
            const nestedMessage: unknown = error.message;
            if (typeof nestedMessage === "string") return nestedMessage;
          }
        }
      }
    }

    // Check for direct message property
    if ("message" in e) {
      const msg: unknown = e.message;
      if (typeof msg === "string") return msg;
    }
  }

  // String error
  if (typeof e === "string") return e;

  return fallback;
}

export default getErrorMessage;
